module.exports = __webpack_public_path__ + "img/horizontal_7_6_7016.ced37743.png";